export interface FreebordSpotlightItem {
  id: string;
  title: {
    en: string;
    he: string;
  };
  description: {
    en: string;
    he: string;
  };
  euroPrice: number;
  nisPrice: number;
  href: string;
  imageSources: string[];
  galleryImages: string[];
  video?: string;
  orderType: 'board' | 'pack';
  sizes: string[];
  hoodieSizes?: string[];
  tagline: {
    en: string;
    he: string;
  };
  bullets: {
    en: string[];
    he: string[];
  };
  theme: string;
  accent: string;
}

export interface FreebordAccessoryItem {
  id: string;
  title: {
    en: string;
    he: string;
  };
  description: {
    en: string;
    he: string;
  };
  nisPrice: number;
  imageSources: string[];
  whatsappLabel: string;
}

export interface FreebordCategoryItem {
  id: string;
  title: {
    en: string;
    he: string;
  };
  description: {
    en: string;
    he: string;
  };
  nisPrice: number;
  imageSources: string[];
  whatsappLabel: string;
}

export const freebordSpotlightItems: FreebordSpotlightItem[] = [
  {
    id: 'fb5x',
    title: {
      en: 'Freebord 5X',
      he: 'Freebord 5X'
    },
    description: {
      en: 'Spring-loaded street snowboard with deeper powder-style carving and easier edge-to-edge learning.',
      he: 'בורד בסגנון סנובורד לרחוב עם מתלה קפיצי, קארב עמוק יותר וכניסה קלה יותר מלב אל הקצה.'
    },
    euroPrice: 449.95,
    nisPrice: 2107,
    href: 'https://eu.freebord.com/shop/freebord-5-x/',
    imageSources: [
      '/freebord/freebord-5x-main.webp'
    ],
    galleryImages: [
      '/freebord/freebord-5x-main.webp',
      '/freebord/freebord-5x-angle.avif',
      '/freebord/freebord-5x-angleback.avif',
      '/freebord/freebord-5x-top.avif'
    ],
    video: 'https://www.youtube.com/embed/CMryroToF3M',
    orderType: 'board',
    sizes: ['77cm', '82cm', '87cm'],
    tagline: {
      en: 'Powder-inspired street setup',
      he: 'סט-אפ רחוב בהשראת פאודר'
    },
    bullets: {
      en: [
        'Independent suspension',
        'Black medium springs on complete boards',
        'Wider turning radius and deeper carve'
      ],
      he: [
        'מתלה עצמאי',
        'קפיצים שחורים בדרגת מדיום על בורדים מלאים',
        'רדיוס פנייה רחב יותר וקארב עמוק יותר'
      ]
    },
    theme: 'from-slate-900 via-sky-900 to-cyan-700',
    accent: 'Street Snowboard'
  },
  {
    id: 'fb5',
    title: {
      en: 'Freebord 5',
      he: 'Freebord 5'
    },
    description: {
      en: 'Original all-rounder focused on maximum stability, smooth carving, and fast progression.',
      he: 'הדגם המקורי והמאוזן, עם פוקוס על יציבות מקסימלית, קארב חלק והתקדמות מהירה.'
    },
    euroPrice: 399.95,
    nisPrice: 1928,
    href: 'https://eu.freebord.com/shop/freebord-5/',
    imageSources: [
      '/freebord/freebord-5-main.webp'
    ],
    galleryImages: [
      '/freebord/freebord-5-main.webp',
      '/freebord/freebord-5-angleback.avif',
      '/freebord/freebord-5-angle.avif',
      '/freebord/freebord-5-top.avif'
    ],
    video: 'https://www.youtube.com/embed/98-RhKZwJG4',
    orderType: 'board',
    sizes: ['77cm', '82cm', '87cm'],
    tagline: {
      en: 'Original all-round stable setup',
      he: 'הסט-אפ המקורי, היציב והמאוזן'
    },
    bullets: {
      en: [
        'Traditional kingpin stability',
        'Super-sized bushings',
        'Fast confidence and progression'
      ],
      he: [
        'יציבות של Traditional Kingpin',
        'בושינגים גדולים במיוחד',
        'בניית ביטחון והתקדמות מהירה'
      ]
    },
    theme: 'from-zinc-900 via-neutral-800 to-stone-600',
    accent: 'All-Rounder'
  },
  {
    id: 'ride-all-year-pack',
    title: {
      en: 'FB5X Ride All Year Pack',
      he: 'FB5X Ride All Year Pack'
    },
    description: {
      en: 'POC highlight pack with FB5X complete, DaBlues wheels, hoodie, and stickers in one bundle.',
      he: 'חבילת דגש ל-POC עם FB5X מלא, גלגלי DaBlues, קפוצ׳ון וסטיקרים בחבילה אחת.'
    },
    euroPrice: 439.95,
    nisPrice: 2071,
    href: 'https://eu.freebord.com/shop/fb5x-ride-all-year-pack/',
    imageSources: [
      '/freebord/ride-all-year-pack-main.avif',
      '/freebord/ride-all-year-pack-board.avif'
    ],
    galleryImages: [
      '/freebord/ride-all-year-pack-main.avif',
      '/freebord/ride-all-year-pack-board.avif',
      '/freebord/ride-all-year-pack-extras.avif',
      '/freebord/ride-all-year-hoodie.avif',
      '/freebord/freebord-dablues.webp'
    ],
    orderType: 'pack',
    sizes: ['77cm', '82cm', '87cm'],
    hoodieSizes: ['S', 'M', 'L', 'XL', 'XXL', '3XL'],
    tagline: {
      en: 'FB5X bundle with hoodie and DaBlues',
      he: 'חבילת FB5X עם קפוצ׳ון ו-DaBlues'
    },
    bullets: {
      en: [
        'FB5X complete board included',
        'DaBlues wheel upgrade included',
        'Premium hoodie and stickers included'
      ],
      he: [
        'כולל בורד FB5X מלא',
        'כולל שדרוג גלגלי DaBlues',
        'כולל קפוצ׳ון פרימיום וסטיקרים'
      ]
    },
    theme: 'from-orange-700 via-amber-600 to-yellow-400',
    accent: 'Bundle'
  }
];

export const freebordAccessories: FreebordAccessoryItem[] = [
  {
    id: 'fb5x-springs-soft',
    title: {
      en: 'FB5X Blue Springs Soft',
      he: 'FB5X Blue Springs Soft'
    },
    description: {
      en: 'Soft spring set for a more forgiving and playful FB5X response.',
      he: 'סט קפיצים רכים לתגובה סלחנית ומשחקית יותר על FB5X.'
    },
    nisPrice: 125,
    imageSources: ['/freebord/accessories/fb5x-springs-soft.webp'],
    whatsappLabel: 'FB5X Blue Springs Soft'
  },
  {
    id: 'fb5x-springs-medium',
    title: {
      en: 'FB5X Black Springs Medium',
      he: 'FB5X Black Springs Medium'
    },
    description: {
      en: 'Medium spring set for a more centered balance between support and flow.',
      he: 'סט קפיצים בדרגת מדיום לאיזון ממורכז יותר בין תמיכה לזרימה.'
    },
    nisPrice: 125,
    imageSources: ['/freebord/accessories/fb5x-springs-medium.webp'],
    whatsappLabel: 'FB5X Black Springs Medium'
  },
  {
    id: 'standard-bearings',
    title: {
      en: 'Standard Bearings',
      he: 'Standard Bearings'
    },
    description: {
      en: 'Standard bearing set for stock replacement and reliable daily riding.',
      he: 'סט מיסבים סטנדרטי להחלפה מקורית ולרכיבה יומיומית אמינה.'
    },
    nisPrice: 90,
    imageSources: ['/freebord/accessories/standard-bearings.webp'],
    whatsappLabel: 'Standard Bearings'
  },
  {
    id: 'upgrade-bearings',
    title: {
      en: 'Upgrade Bearings',
      he: 'Upgrade Bearings'
    },
    description: {
      en: 'Stainless steel upgrade bearing set with higher precision and corrosion resistance.',
      he: 'סט מיסבי נירוסטה משודרג עם דיוק גבוה יותר ועמידות טובה יותר לקורוזיה.'
    },
    nisPrice: 110,
    imageSources: ['/freebord/accessories/upgrade-bearings.png'],
    whatsappLabel: 'Upgrade Bearings'
  },
  {
    id: 'edge-wheel-spacer-8mm',
    title: {
      en: 'Edge Wheel Spacer 8mm',
      he: 'Edge Wheel Spacer 8mm'
    },
    description: {
      en: '8mm spacer for edge wheel tuning and fit adjustments.',
      he: 'ספייסר 8 מ״מ לכיוון והתאמת גלגלי הקצה.'
    },
    nisPrice: 20,
    imageSources: ['/freebord/accessories/edge-wheel-spacer-8mm.png'],
    whatsappLabel: 'Edge Wheel Spacer 8mm'
  }
];

export const freebordWheels: FreebordCategoryItem[] = [
  {
    id: 'dablues-boros',
    title: {
      en: 'DaBlues Boros',
      he: 'DaBlues Boros'
    },
    description: {
      en: 'Classic DaBlues edge wheel set for fast slide initiation and a lighter feel.',
      he: 'סט גלגלי קצה DaBlues הקלאסי לכניסה מהירה יותר לסלייד ותחושה קלה יותר.'
    },
    nisPrice: 320,
    imageSources: ['/freebord/wheels/dablues-boros.webp'],
    whatsappLabel: 'DaBlues Boros'
  },
  {
    id: 'mojo-rojo-boros',
    title: {
      en: 'Mojo Rojo Boros',
      he: 'Mojo Rojo Boros'
    },
    description: {
      en: 'Higher-grip wheel set for riders who want more bite and stronger hold.',
      he: 'סט גלגלים עם גריפ גבוה יותר לרוכבים שרוצים יותר אחיזה והחזקה חזקה יותר.'
    },
    nisPrice: 340,
    imageSources: ['/freebord/wheels/mojo-rojo-boros.png'],
    whatsappLabel: 'Mojo Rojo Boros'
  },
  {
    id: 'cascade',
    title: {
      en: 'Cascade',
      he: 'Cascade'
    },
    description: {
      en: 'Freebord wheel set focused on smooth roll and balanced control.',
      he: 'סט גלגלי Freebord עם דגש על גלגול חלק ושליטה מאוזנת.'
    },
    nisPrice: 280,
    imageSources: ['/freebord/wheels/cascade.webp'],
    whatsappLabel: 'Cascade'
  }
];

export const freebordDecks: FreebordCategoryItem[] = [
  {
    id: 'freebord-deck-space',
    title: {
      en: 'Freebord Deck Space',
      he: 'Freebord Deck Space'
    },
    description: {
      en: 'Graphic deck option with the Space artwork, ready for a fresh complete build.',
      he: 'דק עם גרפיקת Space, מוכן לבנייה של סט-אפ מלא חדש.'
    },
    nisPrice: 760,
    imageSources: ['/freebord/decks/freebord-deck-space.webp'],
    whatsappLabel: 'Freebord Deck Space'
  },
  {
    id: 'freebord-deck',
    title: {
      en: 'Freebord Deck',
      he: 'Freebord Deck'
    },
    description: {
      en: 'Core deck option for replacing or rebuilding a complete Freebord setup.',
      he: 'דק בסיסי להחלפה או לבנייה מחדש של סט-אפ Freebord מלא.'
    },
    nisPrice: 760,
    imageSources: ['/freebord/decks/freebord-deck.webp'],
    whatsappLabel: 'Freebord Deck'
  }
];

export const freebordTrucksBindings: FreebordCategoryItem[] = [
  {
    id: 'freebord-5x-trucks-casters',
    title: {
      en: 'Freebord 5X Trucks & Casters',
      he: 'Freebord 5X Trucks & Casters'
    },
    description: {
      en: '5X truck and caster set for suspension-based carving and deeper powder-style feel.',
      he: 'סט טראקס וקאסטרים של 5X לקארב מבוסס מתלה ותחושת פאודר עמוקה יותר.'
    },
    nisPrice: 690,
    imageSources: ['/freebord/trucks-bindings/freebord-5x-trucks-casters.webp'],
    whatsappLabel: 'Freebord 5X Trucks & Casters'
  },
  {
    id: 'freebord-5-trucks-caster',
    title: {
      en: 'Freebord 5 Trucks & Caster',
      he: 'Freebord 5 Trucks & Caster'
    },
    description: {
      en: 'Classic Freebord 5 truck and caster set for stable all-round riding.',
      he: 'סט טראקס וקאסטר קלאסי של Freebord 5 לרכיבה יציבה ורב-שימושית.'
    },
    nisPrice: 640,
    imageSources: ['/freebord/trucks-bindings/freebord-5-trucks-caster.webp'],
    whatsappLabel: 'Freebord 5 Trucks & Caster'
  },
  {
    id: 'binding-s2',
    title: {
      en: 'Binding S2',
      he: 'Binding S2'
    },
    description: {
      en: 'S2 binding set for locked-in stance and reliable foot retention.',
      he: 'סט ביינדינגים S2 לעמידה נעולה ואחיזת רגל אמינה.'
    },
    nisPrice: 420,
    imageSources: ['/freebord/trucks-bindings/binding-s2.webp'],
    whatsappLabel: 'Binding S2'
  }
];
